// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2c1x8","footer":"Form_footer__3fJRi"};